import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Icon, IconTypes, Modal } from '../../../../../../common';
import { CancelOrderNotificationViewProps } from './order-cancel-notification-modal.models';
import { useStyles } from './order-cancel-notification-modal.styles';
import { Button } from '../../../../../../common/button-new';

export const OrderCancelNotificationModal = ({ onClose, onCreate, onDetails, ...props }: CancelOrderNotificationViewProps) => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Modal
      {...props}
      onClose={onClose}
      className={classes.root}
      propsPaperStyles={classes.modal}
      propsContentStyles={classes.root}
      content={(
        <>
          <h2
            data-testid="consumer-ban-modal-title"
            className={classes.title}
          >
            {intl.formatMessage(
              { id: 'order.cancel.modal.cancelled.title' },
              {
                linebreak: <br />,
              },
            )}
          </h2>
          <div
            className={classes.icon}
            data-testid="consumer-ban-icon"
          >
            <Icon type={IconTypes.cartWithCross} />
          </div>
          <div
            data-testid="consumer-ban-modal-description"
            className={classes.description}
          >
            <FormattedMessage id="order.cancel.modal.cancelled.description" />
          </div>
        </>
      )}
      footer={(
        <div className={classes.footer}>
          <Button
            testId="order-cancel-notification-modal-create"
            style="dark"
            onClick={onCreate}
          >
            <FormattedMessage id="order.cancel.modal.create" />
          </Button>
          <Button
            testId="order-cancel-notification-modal-details"
            style="outlined"
            onClick={onDetails}
          >
            <FormattedMessage id="order.cancel.modal.details" />
          </Button>
        </div>
      )}
    />
  );
};
